import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Button,
  Grid,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import AssistancePendingIlustration from '../../../../assets/img/assistance/assistance_pending.svg';
// import AssistancePendingIlustration from '../../../../assets/img/assistance_pending.png';
import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';

const useStyle = makeStyles(() =>
  createStyles({
    assistanceImg: {
      width: '25%',
      maxWidth: '300px',
      minWidth: '150px',
    },
  })
);

const StatusPending = () => {
  const { success, setOpen } = useAssistanceDataContext();
  const { assistance_status } = success;
  const classes = useStyle();
  const history = useHistory();

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  return (
    <Grid item xs={11}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: '100%' }}
      >
        <Grid item xs={12}>
          <Box my={4} textAlign="center">
            <img
              className={classes.assistanceImg}
              src={AssistancePendingIlustration}
              alt="Asistencia"
            />
          </Box>
          <Typography variant="h6">
            ¡Tu pedido de asistencia fue recibido!
          </Typography>
          <Box my={2}>
            <Typography>
              Te enviaremos una notificación en cuanto te asignemos una grúa,
              este proceso puede demorar según la demanda.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Grid container justify="center">
            <Grid item xs={6} md={4}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={redirectHome}
              >
                Volver a inicio
              </Button>
            </Grid>
          </Grid>
        </Grid>
        {assistance_status.cancelable ? (
          <Grid item xs={6} md={4}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => setOpen(true)}
            >
              Cancelar pedido
            </Button>
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default StatusPending;
